/* eslint-disable semi */
/* eslint-disable quotes */
import "slick-carousel";
import $ from "jquery";

import "animate.css/animate.min.css";
import "slick-carousel/slick/slick.css";

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth",
    });
  });
});

$(document).scroll(function () {
  const headerHeight = $(".header-content").outerHeight();
  const scrolled = $(document).scrollTop();

  let opacity = 1 - scrolled / (headerHeight / 2);
  opacity = Math.max(0, Math.min(1, opacity));

  let blur = (scrolled / headerHeight) * 15;
  blur = Math.min(10, blur);

  $(".reveal-item").css({
    opacity: opacity,
    filter: `blur(${blur}px)`,
  });
});

$(window).on("load", function () {
  setTimeout(() => {
    $(".reveal-container").addClass("reveal-active");
  }, 200);
});

$(document).scroll(function () {
  const headerHeight = $(".header-content").outerHeight() || 500;
  const scrolled = $(document).scrollTop();

  let opacity = 1 - scrolled / (headerHeight / 1.5);
  opacity = Math.max(0, Math.min(1, opacity));

  let blurValue = (scrolled / headerHeight) * 15;
  blurValue = Math.min(10, blurValue);

  $(".reveal-item").css({
    opacity: opacity,
    filter: "blur(" + blurValue + "px)",
  });
});

$("#menu-btn").click(function (e) {
  e.preventDefault();
  $("#mobile-menu").slideToggle();
  $(this).toggleClass("open");
});

$(function () {
  $("#partners-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    infinite: true,
    prevArrow: $(".prev-btn"),
    nextArrow: $(".next-btn"),
    adaptiveHeight: false,
  });
});
